import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';
import { deviceStatsSchema } from '../schemas/device-stats.schema';

/**
 * Gets all devices with older map set data
 * @returns Devices with older map set data
 */
export function getDashboardDeviceStatsDevicesWithOlderMapSetData(
  this: unknown,
  startDate: Date
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetStatsEnvironment.resolve(this)
            .dashboardDeviceStatsDevicesWithOlderMapSetDataUrl
        }?inputDate=${startDate.toISOString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(z.array(deviceStatsSchema)));
}
